import { LinkOutlined } from '@ant-design/icons';
import { Trans } from 'react-i18next';

import useAPIQuery from '../api/useAPIQuery';
import { CandidateDetail } from '../types';

interface CandidateWhatsAppLabelProps {
  candidateId: CandidateDetail['id'];
}

const CandidateWhatsAppLabel = ({ candidateId }: CandidateWhatsAppLabelProps) => {
  const candidate = useAPIQuery(`/candidates/${candidateId}/`);

  const candidatePhoneContact = candidate.data?.phone_contacts?.find(
    (phoneContact) => phoneContact.type === 'PERSONAL'
  );

  return (
    <a
      href={`https://api.whatsapp.com/send?phone=${candidatePhoneContact?.country_code ?? 55}${
        candidatePhoneContact?.number ?? ''
      }`}
      target="_blank"
    >
      <Trans>Enviar WhatsApp</Trans> <LinkOutlined />
    </a>
  );
};

export default CandidateWhatsAppLabel;
